/**
 * /onboard/setup/import
 *
 * Hosts the HistoricalImportDialog. Gated by
 * importEnabledForInternal — flag off → redirect back to the
 * FirstLoginJunction at /onboard/setup.
 */

import { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { useAuth } from '@/contexts/AuthContext';
import { useFeatureFlag } from '@/hooks/useFeatureFlags';
import { HistoricalImportDialog } from '@/components/onboarding/import/HistoricalImportDialog';

const OnboardSetupImport = () => {
  const navigate = useNavigate();
  const { user, activeShop, isShopDataLoading } = useAuth();
  const importEnabled = useFeatureFlag('importEnabledForInternal');

  useEffect(() => {
    if (!user) {
      navigate('/auth', { replace: true });
      return;
    }
    if (!isShopDataLoading && !activeShop) {
      navigate('/onboard', { replace: true });
      return;
    }
    if (importEnabled === false) {
      navigate('/onboard/setup', { replace: true });
    }
  }, [user, activeShop, isShopDataLoading, importEnabled, navigate]);

  if (!user || !activeShop) return null;

  return <HistoricalImportDialog />;
};

export default OnboardSetupImport;
